export default "__VITE_ASSET__ef5b0dd5__"